import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Tengo que saber mucho de cocina?',
  a: 'No, son recetas de máximo 15 minutos, tan fáciles como hacer un huevo frito.'
}, {
  q: '¿Los ingredientes son caros?',
  a: 'Son un poco más costosos que la harina refinada, pero mucho más baratos que una farmacia.'
}, {
  q: '¿Es un libro físico?',
  a: 'No, es un libro digital (PDF) que puedes leer en tu teléfono, tableta o imprimir en casa si prefieres papel.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-light-sage" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-sage" data-id="element-14">
          PREGUNTAS FRECUENTES:
        </h2>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm overflow-hidden" data-id="element-16">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-17">
                <span className="text-xl font-bold text-espresso" data-id="element-18">{faq.q}</span>
                <ChevronDownIcon className={`w-6 h-6 text-sage transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-19" />
              </button>
              <AnimatePresence data-id="element-20">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-21">
                    <div className="px-6 pb-5 text-lg text-espresso/80" data-id="element-22">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}